/* eslint-disable */
export const region13Barangays = [
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'ABILAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'AGONG-ONG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'ALUBIJID',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'GUINABSAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'LOWER OLAVE',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MACALANG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MALAPONG',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MALPOC',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MANAPA',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'MATABAO',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 10',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 5',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 6',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 7',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 8',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'POBLACION 9',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SACOL',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SANGAY',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'SIMBALAN',
    },
    {
        CITY: 'BUENAVISTA',
        BARANGAY: 'TALO-AO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CAHAYAGAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'GOSOON',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'MANOLIGAO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'POBLACION (CARMEN)',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ROJALES',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'TAGCATONG',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'VINAPOR',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'BUHANG',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'CALOC-AN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'GUIASAN',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'MARCOS',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'MAGALLANES',
        BARANGAY: 'TAOD-OY',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'CURVA',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'ESTANISLAO MORGADO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'JAGUPIT',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'PANGAYLAN-IP',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'POBLACION I',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SANTIAGO',
        BARANGAY: 'TAGBUYACAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AGAO POB. (BGY. 3)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AGUSAN PEQUENO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AGUSAN PEQUEÑO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AMBAGO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AMPARO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AMPAYON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'ANTICALA',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'ANTONGALON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'AUPAGAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BAAN KM 3',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BAAN RIVERSIDE POB. (BGY. 20)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BABAG',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BADING POB. (BGY. 22)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BANCASI',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BANZA',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BAOBAOAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BASAG',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BAYANIHAN POB. (BGY. 27)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BILAY',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BITAN-AGAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BIT-OS',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BOBON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BONBON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BUGABUS',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BUGSUKAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'BUHANGIN POB. (BGY. 19)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'CABCABON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'CAMAYAHAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DAGOHOY POB. (BGY. 7)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DANKIAS',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DE ORO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DIEGO SILANG POB. (BGY. 6)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DON FRANCISCO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DOONGAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DULAG',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'DUMALAGAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'FLORIDA',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'GOLDEN RIBBON POB. (BGY. 2)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'HOLY REDEEMER POB. (BGY. 23)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'HUMABON POB. (BGY. 11)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'IMADEJAS POB. (BGY. 24)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'JOSE RIZAL POB. (BGY. 25)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'KINAMLUTAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LAPU-LAPU POB. (BGY. 8)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LEMON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LEON KILAT POB. (BGY. 13)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LIMAHA POB. (BGY. 14)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LOS ANGELES',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'LUMBOCAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MAGUINDA',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MAHAY',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MAHOGANY POB. (BGY. 21)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MAIBU',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MANDAMO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MANILA DE BUGABUS',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MAON POB. (BGY. 1)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MASAO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'MAUG',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'NEW SOCIETY VILLAGE POB. (BGY. 26)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'NONG-NONG',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'OBRERO POB. (BGY. 18)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'ONG YIU POB. (BGY. 16)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'PAGATPATAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'PANGABUGAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'PIANING',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'PIGDAULAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'PINAMANCULAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'PORT POYOHON POB. (BGY. 17 - NEW ASIA)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'RAJAH SOLIMAN POB. (BGY. 4)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SAN IGNACIO POB. (BGY. 15)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SIKATUNA POB. (BGY. 10)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SILONGAN POB. (BGY. 5)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SUMILE',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'SUMILIHON',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'TAGABACA',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'TAGUIBO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'TALIGAMAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'TANDANG SORA POB. (BGY. 12)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'TINIWISAN',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'TUNGAO',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'URDUJA POB. (BGY. 9)',
    },
    {
        CITY: 'BUTUAN',
        BARANGAY: 'VILLA KANANGA',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'ANTONIO LUNA',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'BAYABAS',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'BAY-ANG',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'CAASINAN',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'CABINET',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'CALAMBA',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'CALIBUNAN',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'COMAGASCAS',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'KATUGASAN',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'MAHABA',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 10',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 11',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 12',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 3',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 4',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 5',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 6',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 7',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 8',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'POBLACION 9',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'PUTING BATO',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'SANGHAN',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'SORIANO',
    },
    {
        CITY: 'CABADBARAN',
        BARANGAY: 'TOLOSA',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'A. BELTRAN (CAMALIG)',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'BALEGUIAN',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'BANGONAY',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'COLORADO',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'CUYAGO',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'LIBAS',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'MAGDAGOOC',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'MARAIGING',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'POBLACION (JABONGA)',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'JABONGA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'BANGAYAN',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'CANAWAY',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'CROSSING',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'HINIMBANGAN',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'JALIOBONG',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'SANGAY',
    },
    {
        CITY: 'KITCHARAO',
        BARANGAY: 'SONGKOY',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'AMBACON',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'BALUNGAGAN',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'CASIKLAN',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'CONSORCIA',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'DURIAN',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'EDUARDO G. MONTILLA (CAMBOAYON)',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'IBUAN',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'LINGAYAO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'MALICATO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'MANINGALAO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'MARCOS CALO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'MAT-I',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'PINANA-AN',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LAS-NIEVES',
        BARANGAY: 'TINUCORAN',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'ACLAN',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'AMONTAY',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'ATA-ATAHON',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'CUBI-CUBI',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'CULIT',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'JAGUIMITAN',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'KINABJANGAN',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'PUNTA',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'NASIPIT',
        BARANGAY: 'TRIANGULO',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'BALANGBALANG',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'BASILISA',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'HUMILOG',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'PANAYTAYON',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'POBLACION I (AGAY)',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'POBLACION II',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'REMEDIOS-T.-ROMUALDEZ',
        BARANGAY: 'TAGBONGABONG',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'BINUANGAN',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'CABAYAWA',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'DONA ROSARIO',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'DONA TELESFORA',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'LA FRATERNIDAD',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'TAGMAMARKAY',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'TAGPANGAHOY',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'TINIGBASAN',
    },
    {
        CITY: 'TUBAY',
        BARANGAY: 'VICTORY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'AGSABU',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'AGUINALDO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ANOLINGAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'BAKINGKING',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'BALUBO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'BENTAHON',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'BUNAGUIT',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'CATMONON',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'CEBULAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'CONCORDIA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'CROSSING LUNA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'CUBO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'DAKUTAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'DUANGAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'GUADALUPE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'GUIBONON',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'HAWILIAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'KALABUAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'KINAMAYBAY',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'LABAO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'LANGAG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MAC-ARTHUR',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MAHAGCOT',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MALIWANAG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'MILAGROS',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'NATO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'NEW GINGOOG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ODIONG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'ORO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'PIGLAWIGAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'REMEDIOS',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SALUG',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SAN TORIBIO',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SEGUNDA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'SINAKUNGAN',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TAGABASE',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TAGANAHAW',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TAGBALILI',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TAHINA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'TANDANG SORA',
    },
    {
        CITY: 'ESPERANZA',
        BARANGAY: 'VALENTINA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'ANGELES',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'BATAAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'COMOTA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'HALAPITAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'KASAPA II',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LANGASIAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'LYDIA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'OSMENA SR.',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'PANAGANGAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SABANG ADGAWAN',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SAGUNTO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'SAN PATRICIO',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'VALENTINA',
    },
    {
        CITY: 'LA-PAZ',
        BARANGAY: 'VILLA PAZ',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'BINUCAYAN',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'JOHNSON',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'KASAPA',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'MAGAUD',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'NUEVA GRACIA',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SABUD',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SAN MARIANO',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SANTA TERESA',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SANTO TOMAS',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'VIOLANTA',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'WALOE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'BAYUGAN 3',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CABANTAO',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'CABAWAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'LIBUAC',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'MARFIL',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'NOVELE',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'TAGBAYAGAN',
    },
    {
        CITY: 'ROSARIO',
        BARANGAY: 'WASI-AN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BAYUGAN 2',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BITAN-AGAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BORBON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BUENASUERTE',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'CAIMPUGAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'DAS-AGAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'EBRO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'HUBANG',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'KARAUS',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'LADGADAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'LAPINIGAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'LUCAC',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MATE',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'ORMACA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PASTA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'PISA-AN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'SANTA ANA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'TAGAPUA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'ANISLAGAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BALIT',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BAYLO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'BINICALAN',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'CECILIA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'COALICION',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'CULI',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DIMASALANG',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DON ALEJANDRO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DON PEDRO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DONA FLAVIA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'DONA MAXIMA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MAHAGSAY',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MAHAPAG',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'MURITULA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'NUEVO TRABAJO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'POLICARPO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA INES',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'SANTIAGO',
    },
    {
        CITY: 'SAN-LUIS',
        BARANGAY: 'WEGGUAM',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'BERSEBA',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'BUCAC',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'CAGBAS',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'CALAITAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'CANAYUGAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'CHARITO',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'CLARO CORTEZ',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'FILI',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'GAMAO',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'GETSEMANE',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'GRACE ESTATE',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'HAMOGAWAY',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MAGKIANGKANG',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MAHAYAG',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MARCELINA',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MAYGATASAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MONTIVESTA',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MT. ARARAT',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MT. CARMEL',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'MT. OLIVE',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'NEW SALEM',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'NOLI',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'PANAYTAY',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'PINAGALAAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SAGMONE',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SAGUMA',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SAN AGUSTIN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SANTA IRENE',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SANTA TERESITA',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'TAGLATAWAN',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'TAGLIBAS',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'TAGUBAY',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'VERDU',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'VILLA UNDAYON',
    },
    {
        CITY: 'BAYUGAN',
        BARANGAY: 'WAWA',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'BUNAWAN BROOK',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'MAMBALILI',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'NUEVA ERA',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'SAN ANDRES',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'SAN MARCOS',
    },
    {
        CITY: 'BUNAWAN',
        BARANGAY: 'SAN TEODORO',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'AWA',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'AZPETIA',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LA CARIDAD',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LA PERIAN',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LA PURISIMA',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LA SUERTE',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LA UNION',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LAS NAVAS',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LOS ARCOS',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'LUCENA',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'MAPAGA',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'NAPO',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'NEW MAUG',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'PATIN-AY',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'POBLACION (BAHBAH)',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SALIMBOGAON',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN JOAQUIN',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN LORENZO',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN MARTIN',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN RAFAEL',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN SALVADOR',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SANTA IRENE',
    },
    {
        CITY: 'PROSPERIDAD',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'ANGAS',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'AWAO',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'CONCEPCION',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'PAG-ASA',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'PATROCINIO',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'SANTA ISABEL',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'SAYON',
    },
    {
        CITY: 'SANTA-JOSEFA',
        BARANGAY: 'TAPAZ',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'AFGA',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'ANAHAWAN',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'BANAGBANAG',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'EL RIO',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'ILIHAN',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'KIOYA',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'KOLAMBUGAN',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'MAGKALAPE',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'NEW TUBIGON',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'PADIAY',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'PEREZ',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'SINAI',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'TABON-TABON',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'TAG-UYANGO',
    },
    {
        CITY: 'SIBAGAT',
        BARANGAY: 'VILLANGIT',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'BATUCAN',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'BUENAGRACIA',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'CAUSWAGAN',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'CULI',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'DESAMPARADOS',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'LA FLORA',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'LABNIG',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'MAHARLIKA',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'MARBON',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'SABANG GIBUNG',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'SAN AGUSTIN (POB.)',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'SAN NICOLAS (POB.)',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'ZAMORA',
    },
    {
        CITY: 'TALACOGON',
        BARANGAY: 'ZILLOVIA',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'BASA',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'CEBOLIN',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'CUEVAS',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'KAPATUNGAN',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'LANGKILA-AN',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'MANAT',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'NEW VISAYAS',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'PANGYAN',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'PULANG-LUPA',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'SAN IGNACIO',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'TRENTO',
        BARANGAY: 'TUDELA',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'ANITAP',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'BACAY II',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'BINONGAN',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'CAIGANGAN',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'CANDIIS',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'DEL MONTE',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'DON MATEO',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'LA FORTUNA',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'LIMOT',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'MASAYAN',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SAMPAGUITA',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SAN GABRIEL',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SANTA EMELIA',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SAWAGAN',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SINOBONG',
    },
    {
        CITY: 'VERUELA',
        BARANGAY: 'SISIMON',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'BENGLEN',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'CATADMAN',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'COLUMBUS',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'CORING',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'CORTES',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'DIEGAS',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'DONA HELENE',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'EDERA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'FERDINAND',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'GEOTINA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'IMEE (BACTASAN)',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'MELGAR',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'MONTAG',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'NAVARRO',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'NEW NAZARETH',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'PUERTO PRINCESA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'RITA GLENDA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'ROMA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'SANTA MONICA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'SERING',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'SOMBRADO',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'TAG-ABACA',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'VILLA ECLEO',
    },
    {
        CITY: 'BASILISA',
        BARANGAY: 'VILLA PANTINOPLE',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'BOA',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'CABUNGA-AN',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'LAGUNA',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'LEGASPI',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'MA-ATAS',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'MABINI (BORJA)',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'NUEVA ESTRELLA',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'R. ECLEO',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'R. ECLEO SR.',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'SANTA RITA',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'TIGBAO',
    },
    {
        CITY: 'CAGDIANAO',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'BAGUMBAYAN',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'CABAYAWAN',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'CAB-ILAN',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'CAYETANO',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'ESCOLTA (POB.)',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'GOMEZ',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'JUSTINIANA EDERA',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'MAUSWAGON (POB.)',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'NEW MABUHAY',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'WADAS',
    },
    {
        CITY: 'DINAGAT',
        BARANGAY: 'WHITE BEACH (POB.)',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'CARMEN (POB.)',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'FERDINAND',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'HELENE',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'LIBERTY',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'PANAMAON',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SAN JUAN (POB.)',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'LORETO',
        BARANGAY: 'SANTIAGO (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'AURELIO',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'CUARINTA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'DON RUBEN ECLEO (BALTAZAR)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'JACQUEZ',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'JUSTINIANA EDERA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'MATINGBE',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SAN-JOSE',
        BARANGAY: 'WILSON',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'ALBOR (POB.)',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'ARELLANO',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'BAYANIHAN',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'DONA HELEN',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'GENERAL AGUINALDO (BOLOD-BOLOD)',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'KANIHAAN',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'LLAMERA',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'PLARIDEL',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'ROSITA',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'SAN ANTONIO (POB.)',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'LIBJO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'DIAZ (ROMUALDEZ)',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'IMELDA',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'NAVARRO',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'SAN ROQUE (POB.)',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'SAN VICENTE (POB.)',
    },
    {
        CITY: 'TUBAJON',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'CAMBUAYON',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'CAMPO',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'DUGSANGON',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'PAUTAO',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'PAYAPAG',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'PUNGTOD',
    },
    {
        CITY: 'BACUAG',
        BARANGAY: 'SANTO ROSARIO',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'BAGAKAY (POB. WEST)',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'CABUGO',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'CAGDIANAO',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'DAYWAN',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'HAYANGGABON',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'LADGARON (POB.)',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'LAPINIGAN',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'MAGALLANES',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'PANATAO',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'SAPA',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'TAGANITO',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'TAYAGA (POB. EAST)',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'URBIZTONDO',
    },
    {
        CITY: 'CLAVER',
        BARANGAY: 'WANGKE',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BAGAKAY',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 1 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 10 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 11 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 12 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 13 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 2 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 3 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 4 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 5 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 6 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 7 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 8 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BARANGAY 9 (POB.)',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'CABAWA',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'CAMBAS-AC',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'CORREGIDOR',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'DAGOHOY',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'DON PAULINO',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'JUBANG',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'MONTSERRAT',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'SAN CARLOS',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'SANTA FELOMINA',
    },
    {
        CITY: 'DAPA',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'BAGAKAY (ALBURO)',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'BITOON',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'CABUGAO',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'CANCOHOY',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'CAUB',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'DEL CARMEN (POB.)',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'DOMOYOG',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'HALIAN',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'JAMOYAON',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'LOBOGON',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'SAN JOSE (POB.)',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'SAYAK',
    },
    {
        CITY: 'DEL-CARMEN',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'ALAMBIQUE (POB.)',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'CAMAM-ONAN',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'CAM-BOAYON',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'IPIL (POB.)',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'LAHI',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'MAHANUB',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'PONIENTE',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'SAN ANTONIO (BONOT)',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'SICO-SICO',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'VILLAFLOR',
    },
    {
        CITY: 'GIGAQUIT',
        BARANGAY: 'VILLAFRANCA',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'BINGA',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'BOBONA-ON',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'CANTUGAS',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'DAYANO',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'MAGPAYANG',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'MANSAYAO',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'MARAYAG',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'PACO',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'QUEZON (POB.)',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'SAN FRANCISCO',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'SIANA',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'SILOP',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'TAGBUYAWAN',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'TAPI-AN',
    },
    {
        CITY: 'MAINIT',
        BARANGAY: 'TOLINGON',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'BUNYASAN',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'CAGTINAE',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'CAN-AGA',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'CANSAYONG',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'CANTAPOY',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'CAYAWAN',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'DORO (BINOCARAN)',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'HANAGDONG',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'KARIHATAG',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'MASGAD',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'PILI',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'SAN ISIDRO (POB.)',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'TINAGO',
    },
    {
        CITY: 'MALIMONO',
        BARANGAY: 'VILLARIZA',
    },
    {
        CITY: 'SAN-BENITO',
        BARANGAY: 'BONGDO',
    },
    {
        CITY: 'SAN-BENITO',
        BARANGAY: 'MARIBOJOC',
    },
    {
        CITY: 'SAN-BENITO',
        BARANGAY: 'NUEVO CAMPO',
    },
    {
        CITY: 'SAN-BENITO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SAN-BENITO',
        BARANGAY: 'SANTA CRUZ (POB.)',
    },
    {
        CITY: 'SAN-BENITO',
        BARANGAY: 'TALISAY (POB.)',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'AMONTAY',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BALITE',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'BANBANON',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'DIAZ',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'HONRADO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'JUBGAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'LINONGGANAN',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MACOPA',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'MAGTANGALE',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'OSLAO',
    },
    {
        CITY: 'SAN-FRANCISCO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'ABAD SANTOS',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'BAILAN',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'GARCIA',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'MABUHAY (POB.)',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'T. ARLAN (POB.)',
    },
    {
        CITY: 'SANTA-MONICA',
        BARANGAY: 'TANGBO',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'ALANG-ALANG',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'ANOMAR',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'AURORA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'BALIBAYON',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'BILABID',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'BITAUGAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'BONIFACIO',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CABONGBONGAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CAGNIOG',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CAGUTSAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CANLANIPA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CANTIASAY',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CAPALAYAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'CATADMAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'DANAO',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'DANAWAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'DAY-ASAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'IPIL',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'LIBUAC',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'LIPATA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'LISONDRA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'LUNA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'MABUA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'MANYAGAO',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'MAPAWA',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'MAT-I',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'NABAGO',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'NONOC',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'OROK',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'POCTOY',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'PUNTA BILAR',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SAN PEDRO (HANIGAD)',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SERNA (BAD-ASAY)',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SIDLAKAN',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SILOP',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SUGBAY',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'SUKAILANG',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'TAFT (POB.)',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'TOGBONGON',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'WASHINGTON (POB.)',
    },
    {
        CITY: 'SURIGAO',
        BARANGAY: 'ZARAGOZA',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'ALIPAO',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'ANAHAW',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'BUDLINGIN',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'CAMP EDUARD (GEOTINA)',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'FERLDA',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'GAMUTON',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'JULIO OUANO (POB.)',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'OMBONG',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'POBLACION (ALEGRIA)',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'PONGTUD',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'ALEGRIA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BAYBAY',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'BITAUG',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'MATIN-AO',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'POBLACION 1',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'POBLACION 2',
    },
    {
        CITY: 'BURGOS',
        BARANGAY: 'SAN MATEO',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'ANAJAWAN',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'CABITOONAN',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'CATANGNAN',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'CORAZON',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'DAKU',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'LA JANUZA',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'LIBERTAD',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'MALINAO',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'POBLACION I (PUROK I)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'POBLACION II (PUROK II)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'POBLACION III (PUROK III)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'POBLACION IV (PUROK IV)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'POBLACION V (PUROK V)',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'SUYANGAN',
    },
    {
        CITY: 'GENERAL-LUNA',
        BARANGAY: 'TAWIN-TAWIN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'ASINAN (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CARIDAD',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CENTRO (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'CONSOLACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DATU',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'DAYAOHAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'JABOY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'KATIPUNAN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MAASIN',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PILARING (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'PUNTA (POB.)',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'PILAR',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'AMOSLOG',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'ANISLAGAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'BAD-AS',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'BOYONGAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'BUGAS-BUGAS',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'CENTRAL (POB.)',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'ELLAPERAL (NONOK)',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'IPIL (POB.)',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'LAKANDULA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MABINI',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MACALAYA',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MAGSAYSAY (POB.)',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'MAGUPANGE',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'PANANAY-AN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'PANHUTONGAN',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'SANI-SANI',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'SUYOC',
    },
    {
        CITY: 'PLACER',
        BARANGAY: 'TAGBONGABONG',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'BUHING CALIPAY',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DEL CARMEN (POB.)',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'MACAPAGAL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PACIFICO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'PELAEZ',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SAN MIGUEL',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SANTA PAZ',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TAMBACAN',
    },
    {
        CITY: 'SAN-ISIDRO',
        BARANGAY: 'TIGASAO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'BIYABID',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'GACEPAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'IMA',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'LOWER PATAG',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'MAYAG',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'POBLACION (SAN PEDRO)',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'TAGBAYANI',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'TINOGPAHAN',
    },
    {
        CITY: 'SISON',
        BARANGAY: 'UPPER PATAG',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'ALBINO TARUC',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'DEL PILAR',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'HELENE',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'HONRADO',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'NAVARRO (POB.)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'NUEVA ESTRELLA',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'PAMOSAINGAN',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'RIZAL (POB.)',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SALOG',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SERING',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SONGKOY',
    },
    {
        CITY: 'SOCORRO',
        BARANGAY: 'SUDLON',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'CAPAYAHAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'CAWILAN',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'DEL ROSARIO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'MARGA',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'MOTORPOOL',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'POBLACION (TUBOD)',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'SAN PABLO',
    },
    {
        CITY: 'TUBOD',
        BARANGAY: 'TIMAMANA',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'AURORA (POB.)',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'AZUCENA (POB.)',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'BANBAN',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'CAWILAN',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'FABIO',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'HIMAMAUG',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'LAUREL',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'LOWER LIBAS',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'OPONG',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'PATINO',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'SAMPAGUITA (POB.)',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'TALAVERA',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'TAGANA-AN',
        BARANGAY: 'UPPER LIBAS',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'AMAGA',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'BAHI',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'CABACUNGAN',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'CAMBAGANG',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'CAUSWAGAN',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'DAPDAP',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'DUGHAN',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'GAMUT',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'JAVIER',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'KINAYAN',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'MAMIS',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'RIZAL',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'SUA',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'SUDLON',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'TAMBIS',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'UNIDAD',
    },
    {
        CITY: 'BAROBO',
        BARANGAY: 'WAKAT',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'AMAG',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'BALETE (POB.)',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'CABUGO',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'CAGBAOTO',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'LA PAZ',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'MAGOBAWOK',
    },
    {
        CITY: 'BAYABAS',
        BARANGAY: 'PANAOSAWON',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'BUCTO',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'BURBOANAN',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'CAGUYAO',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'COLETO',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'COMAWAS',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'KAHAYAG',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'LABISMA',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'LAWIGAN',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'MAHARLIKA',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'MANGAGOY',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'MONE',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'PAMANLINAN',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'PAMAYPAYAN',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SAN FERNANDO',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SAN ISIDRO (BAGNAN)',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SAN ROQUE (CADANGLASAN)',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'SIBAROY',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'TABON',
    },
    {
        CITY: 'BISLIG',
        BARANGAY: 'TUMANAN',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'ARAS-ASAN',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'BITAUGAN EAST',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'BITAUGAN WEST',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'LA PURISIMA (PALHE)',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'LACTUDAN',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'MAT-E',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'TAWAGAN',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'TUBO-TUBO',
    },
    {
        CITY: 'CAGWAIT',
        BARANGAY: 'UNIDAD',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'BUGSUKAN',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'BUNTALID',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'CABAS-AN',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'CALAGDAAN',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'CONSUELO',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'GENERAL ISLAND',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'LININTI-AN (POB.)',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'LOBO',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'MAGASANG',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'MAGOSILOM (POB.)',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'PAG-ANTAYAN',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'PALASAO',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'PARANG',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'TAPI',
    },
    {
        CITY: 'CANTILAN',
        BARANGAY: 'TIGABONG',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'ADLAY',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'BABUYAN',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'BACOLOD',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'BAYBAY (POB.)',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'BON-OT',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'CAGLAYAG',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'DAHICAN',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'DOYOS (POB.)',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'EMBARCADERO (POB.)',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'GAMUTON',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'PANIKIAN',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'PANTUKAN',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'SACA (POB.)',
    },
    {
        CITY: 'CARRASCAL',
        BARANGAY: 'TAG-ANITO',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'BACULIN',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'BENIGNO AQUINO (ZONE I POB.)',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'BIGAAN',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'CAMBATONG',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'CAMPA',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'DUGMANON',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'HARIP',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'LA CASA (POB.)',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'LOYOLA',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'MALIGAYA',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'PAGTIGNI-AN (BITOON)',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'POCTO',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'PORT LAMON',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'ROXAS',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'SASA',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'TAGASAKA',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'TAGBOBONGA',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'TALISAY',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'TARUSAN',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'TIDMAN',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'TIWI',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'HINATUAN',
        BARANGAY: 'ZONE III MAHARLIKA (POB.)',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'AGSAM',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'BOCAWE',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'BUNGA',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'GAMUTON',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'HABAG',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'MAMPI',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'NURCIA',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'PAKWAN',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'SIBAHAY',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'ZONE I (POB.)',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'ZONE II (POB.)',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'ZONE III (POB.)',
    },
    {
        CITY: 'LANUZA',
        BARANGAY: 'ZONE IV (POB.)',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'BANAHAO',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'BAN-AS',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'BAUCAWE',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'DIATAGON',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'GANAYON',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'LIATIMCO',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'MANYAYAY',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'PAYASAN',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'SAINT CHRISTINE',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'LIANGA',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'ANIBONGAN',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'BARCELONA',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'BOGAK',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'BONGAN',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'HANDAMAYAN',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'MAHAYAHAY',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'MANDUS',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'MANSA-ILAO',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'PAGTILA-AN',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'PALO ALTO',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'RAJAH CABUNGSO-AN',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'SABANG',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'TAGPOPORAN',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'LINGIG',
        BARANGAY: 'VALENCIA',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'BAGSAC',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'BAYOGO',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'LINIBONAN',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'MANGA',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'PANAYOGON',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'PATONG PATONG',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'QUIRINO (POB.)',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'SAN JUAN',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'SONGKIT',
    },
    {
        CITY: 'MADRID',
        BARANGAY: 'UNION',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'ALEGRIA',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'AMONTAY',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'ANTIPOLO',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'AROROGAN',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'BAYAN',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'MAHABA',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'MARARAG',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'SAN PEDRO',
    },
    {
        CITY: 'MARIHATAG',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ANTAO',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CANCAVAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'CARMEN (POB.)',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'ESPERANZA',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'HINAPOYAN',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'PUYAT',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'CARMEN',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'BALIBADON',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'BURGOS',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'CAPANDAN',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MABAHIN',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MADRELINO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MANLICO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'MATHO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'TAG-ANONGAN',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'TIGAO',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'TUBORAN',
    },
    {
        CITY: 'CORTES',
        BARANGAY: 'UBA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BRETANIA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BUATONG',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'BUHISAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'GATA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'HORNASAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'JANIPAAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'KAUSWAGAN',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'OTEIZA',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'PONG-ON',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'PONGTOD',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SANTO NINO',
    },
    {
        CITY: 'SAN-AGUSTIN',
        BARANGAY: 'SANTO NIÑO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BAGYANG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BARAS',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BITAUGAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'BOLHOON',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CALATNGAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CARROMATA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'CASTILLO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LIBAS GUA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'LIBAS SUD',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MAGROYONG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'MAHAYAG (MAITUM)',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'PATONG',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAGBAYAN',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SAN ROQUE',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'SIAGAO',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'TINA',
    },
    {
        CITY: 'SAN-MIGUEL',
        BARANGAY: 'UMALAG',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'BATUNAN',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'CARPENITO',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'DONA CARMEN',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'HINAGDANAN',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'KAHAYAGAN',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'LAGO',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'MAGLAMBING',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'MAGLATAB',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'MAGSAYSAY',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'MALIXI',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'MANAMBIA',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'OSMENA',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'POBLACION',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SAN VICENTE',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SANTA CRUZ',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SANTA FE',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SANTA JUANA',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SANTA MARIA',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SAYON',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'SORIANO',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'TAGONGON',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'TRINIDAD',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'UGOBAN',
    },
    {
        CITY: 'TAGBINA',
        BARANGAY: 'VILLAVERDE',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'ALBA',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'ANAHAO BAG-O',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'ANAHAO DAAN',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'BADONG',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'BAJAO',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'BANGSUD',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'CABANGAHAN',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'CAGDAPAO',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'CAMAGONG',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'CARAS-AN',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'CAYALE',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'DAYO-AN',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'GAMUT',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'JUBANG',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'KINABIGTASAN',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'LAYOG',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'LINDOY',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'MERCEDES',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'PURISIMA (POB.)',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'SUMO-SUMO',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'UMBAY',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'UNABAN',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'UNIDOS',
    },
    {
        CITY: 'TAGO',
        BARANGAY: 'VICTORIA',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'AWASIAN',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'BAGONG LUNGSOD (POB.)',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'BIOTO',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'BONGTOD POB. (EAST WEST)',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'BUENAVISTA',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'DAGOCDOC (POB.)',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'MABUA',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'MABUHAY',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'MAITUM',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'MATICDUM',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'PANDANON',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'PANGI',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'QUEZON',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'ROSARIO',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'SALVACION',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'SAN AGUSTIN NORTE',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'SAN AGUSTIN SUR',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'SAN ANTONIO',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'SAN ISIDRO',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'SAN JOSE',
    },
    {
        CITY: 'TANDAG',
        BARANGAY: 'TELAJE',
    }
];
